import { render, staticRenderFns } from "./CDetails.vue?vue&type=template&id=2c773e7a&"
import script from "./CDetails.vue?vue&type=script&lang=js&"
export * from "./CDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports